import type { Feature } from '@getstep/proto/feature'
import { useEffect } from 'react'

import { useStores } from '@lib/store/useStores'

export const useOverrideFeature = (feature: Feature, enabled: boolean) => {
    const { featureOverrideStore } = useStores()

    useEffect(() => {
        featureOverrideStore.overrideFeature(feature, enabled)
    }, [enabled, feature, featureOverrideStore])
}
